import * as React from 'react';

import { ErrorList } from '../components';

type Props = Readonly<{
  formErrorList: string[];
  handleSubmit: () => unknown;
  children: React.ReactNode;
}>;

export default function FormWrap({
  formErrorList,
  handleSubmit,
  children,
}: Props) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <ErrorList errors={formErrorList} />
      {children}
    </form>
  );
}
